// kfe-sparkline.js — inline-SVG sparkline.
//
// PORT TARGET: Classes/KFEModules/Reports/ChartViews/KFESparklineView.swift
//
// Same shape as kfe-line-chart but constrained, no padding, lower height.

import { KFEComponent } from "../core/component.js";
import { html } from "../core/html.js";

export class KFESparkline extends KFEComponent {
  static props = ["data"];
  static styles = `
    :host { display: inline-block; width: 100%; height: 24px; }
    svg { width: 100%; height: 100%; }
    path { fill: none; stroke: var(--kfe-accent); stroke-width: 1.5; vector-effect: non-scaling-stroke; }
  `;

  render() {
    const data = /** @type {number[]} */ (/** @type {any} */ (this).data) ?? [];
    if (data.length === 0) return html`<svg viewBox="0 0 100 20"></svg>`;
    const max = Math.max(...data, 1);
    const min = Math.min(...data, 0);
    const range = max - min || 1;
    const dx = 100 / Math.max(1, data.length - 1);
    const points = data.map((v, i) => `${(i * dx).toFixed(2)},${(20 - ((v - min) / range) * 20).toFixed(2)}`);
    const ns = "http://www.w3.org/2000/svg";
    const svg = document.createElementNS(ns, "svg");
    svg.setAttribute("viewBox", `0 0 100 20`);
    svg.setAttribute("preserveAspectRatio", "none");
    const path = document.createElementNS(ns, "path");
    path.setAttribute("d", "M " + points.join(" L "));
    svg.appendChild(path);
    return html`${svg}`;
  }
}
